import React from 'react';
import "./AboutStyles.css";
import sabeer from "../../assets/images/about-us/Sabeer.webp";
import dilan from "../../assets/images/about-us/Dhilan.webp";
import nihila from "../../assets/images/about-us/Nihila.webp";
import aboutUsImage from "../../assets/images/about-us/sri-lanka-group2.jpeg";

const teamMembers = [
  {
    name: "Dilan De Silva",
    role: "Managing Director",
    description: "Mr. Dilan De Silva oversees the smooth running of the business and is responsible for developing strategies to hit or exceed sales targets, and for staff, financial and daily operational management.",
    imgSrc: dilan,
  },
  {
    name: "Sabeer",
    role: "Founder & CEO",
    description: "Mr. Sabeer is a dynamic and visionary entrepreneur hailing from Lakshadweep, distinguished for spearheading and steering a diverse portfolio of successful ventures.",
    imgSrc: sabeer
  },
  {
    name: "Nihila Aboo",
    role: "Director",
    description: "Ms. Nihila Aboo is responsible for the organisation's daily operations, including reservations, ticketing, travel coordination, and customer service.",
    imgSrc: nihila
  }
];

const AboutUs = () => {
  return (
    <>

    <div className="about-us-card">
        <div className="about-us-image">
            <img src={aboutUsImage} alt="About Us" />
        </div>
        <div className="about-us-content">
            <h2>ABOUT US</h2>

            <p>
            At GoL Travels, we believe travel isn’t just about visiting places; it's also about creating stories your clients will cherish forever. As a trusted B2B partner, we bring the vibrant essence of Sri Lanka closer to your business, offering tailored travel experiences that align perfectly with your clients’ expectations.
            
              From beachfront resorts to charming boutique stays, we provide accommodations that leave a lasting impression. Our deep-rooted connections ensure you get access to the best in class, whether it’s serene coastal retreats or hidden gems in Sri Lanka’s lush hill country.
           
            The experiences we curate are designed to inspire. Whether it is a heart-pounding wildlife safari or an exploration of ancient cultural wonders at a UNESCO cultural heritage site, every activity is crafted to offer a unique glimpse into Sri Lanka’s diverse beauty.
            </p>
            <p>
            Transportation is more than getting from one place to another; it’s about travelling in comfort and style. With our fleet of modern vehicles and professional drivers, we ensure every journey is smooth, safe, and stress-free.
            
            What sets us apart is our commitment to excellence. We’re not just providing services; we're also adding value to your business by delivering seamless operations, personalised support, and memorable journeys for your clients.
            
              With GoL Travels as your partner, you’re not just offering a trip to Sri Lanka; you’re delivering an experience they’ll want to relive again and again.
            </p>
            <p>Let’s redefine travel together, one unforgettable journey at a time.</p>
        </div>
        </div>
    
   
    <div className="about-us-container">
      {teamMembers.map((member, index) => (
        <div className="about-card" key={index}>
          <div className="image-container">
            <img src={member.imgSrc} alt={member.name} />
          </div>
          <h2>{member.name}</h2>
          <h3>{member.role}</h3>
          <p>{member.description}</p>
        </div>
      ))}
    </div>
    </>
  );
};

export default AboutUs;

